import { EXPRESS_API } from 'configs/api/expressApi';
import { CreateSnippetParams } from '.';

export type GetSnippetsParams = {
  start?: number;
  limit?: number;
  search?: string;
  sort?: string;
  sharedWith?: string;
};

export const getSnippets = async (params: GetSnippetsParams) => {
  const response = await EXPRESS_API.get(`/snippets`, { params });
  return response.data;
};

export const getSnippet = async (snippetId: string) => {
  const response = await EXPRESS_API.get(`/snippets/${snippetId}`);
  return response.data;
};

export const createSnippet = async ({ data }: CreateSnippetParams) => {
  const response = await EXPRESS_API.post(`/snippets`, data);
  return response.data;
};

export const updateSnippet = async (data: any) => {
  const response = await EXPRESS_API.put(`/snippets/${data.snippetId}`, data);
  return response.data;
};

export const deleteSnippet = async ({ data }: any) => {
  const response = await EXPRESS_API.delete(`/snippets/${data.snippetId}`, {
    data,
  });
  return response.data;
};

export const deleteSnippets = async ({ data }: any) => {
  const response = await EXPRESS_API.delete(`/snippets`, { data });
  return response.data;
};
